// FLAGS: authorization
// Wire shapes for the auth endpoints, including the role enum the CustomerSuccess gate compares against.
export type TwoFactorVerification = "pending" | "not_required";

export const AUTHENTICATOR_KEY_PROVIDER = "AuthenticatorKey";

export interface LoginCodeFlowResponse {
  userId?: string;
  email?: string;
  twoFactorVerification: TwoFactorVerification;
  userTokenProviders?: string[];
}

/**
 * FLAGS: authorization
 * Member order *is* the wire value, so reordering or inserting a member shifts every
 * number and the gate then admits or denies the wrong role with nothing to report it.
 * Mirrors OpenUp.Services/Models/OpenUpRole.cs (member order = wire value).
 * The API serializes role enums as integers (Newtonsoft default, no
 * StringEnumConverter) — same mapping OpenUp.Admin uses.
 */
export enum OpenUpRole {
  Automation = 0,
  Guest = 1,
  Client = 2,
  Expert = 3,
  Admin = 4,
  Manager = 5,
  Consult = 6,
  Checkin = 7,
  Host = 8,
  CustomerSuccess = 9,
  HumanResource = 10,
  Support = 11,
}

/**
 * Subset of GET /api/v2/users/profile (OpenUp.Api UserResponse) — the same
 * whoami both OpenUp.Admin and the customer-success-dashboard gate roles on.
 * Note: its policy requires one of Guest/Client/Expert/Support/Host, so a
 * hypothetical CustomerSuccess-ONLY account gets a 403; in practice CS staff
 * always also carry Client/Support (same dependency as the CS dashboard).
 */
export interface UserProfile {
  id?: string;
  email: string;
  firstName?: string;
  lastName?: string;
  /** Integers on the wire; strings tolerated in case serialization changes. */
  roles?: Array<OpenUpRole | string>;
}
